import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import {DragSource, DropTarget} from "react-dnd";

import {LoadingIcon} from "@ergeon/erg-components-react";

import {TIME_FORMAT} from "config/constants";
import {Destination} from "v2/api/Records";
import DestinationAddress from "v2/components/DestinationAddress";
import DestinationTitle from "v2/components/DestinationTitle";
import {durationToUnits} from "utils";

const DESTINATION_NODE = "destination-node";

const DraggableDestination = (props) => {
  const {
    connectDragSource,
    connectDropTarget,
    data,
    data: {duration, estEndTime, estStartTime},
    isDragging,
    timesLoading,
  } = props;

  const titleClassName = classnames("erg-margin-left-15", {
    "text-muted": !data.address,
  });

  let timings = <LoadingIcon />;
  if (!timesLoading) {
    timings =
      `${estStartTime.format(TIME_FORMAT)} to ${estEndTime.format(TIME_FORMAT)} ` +
      `(${durationToUnits(duration, "minutes")} min)`;
  }

  return connectDragSource(connectDropTarget(
    <div
      className="Draggable"
      style={{opacity: Number(!isDragging)}}>
      <div className="Draggable-Content">
        <strong>#{data.slot}</strong>
        <DestinationTitle className={titleClassName} data={data} />
        <DestinationAddress
          className="erg-margin-left-15 small"
          data={data} />
        <small className="text-muted erg-margin-left-15">
          {timings}
        </small>
      </div>
      <div className="Draggable-IconContainer">
        <i className="fa fa-bars" />
      </div>
    </div>
  ));
};

DraggableDestination.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  data: PropTypes.instanceOf(Destination).isRequired,
  isDragging: PropTypes.bool.isRequired,
  onBeginDrag: PropTypes.func.isRequired,
  onEndDrag: PropTypes.func.isRequired,
  onMove: PropTypes.func.isRequired,
  timesLoading: PropTypes.bool.isRequired,
};

const dragFunc = (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
};

const dropFunc = (connect) => {
  return {
    connectDropTarget: connect.dropTarget(),
  };
};

const taskSource = {
  beginDrag(props) {
    props.onBeginDrag();
    return {
      data: props.data,
      timesLoading: props.timesLoading,
    };
  },

  endDrag(props, monitor) {
    props.onEndDrag(monitor.didDrop());
  },

  isDragging(props, monitor) {
    return props.data.id === monitor.getItem().data.id;
  },
};

const taskTarget = {
  hover(props, monitor) {
    const {id: draggedId} = monitor.getItem().data;
    const {id: afterId} = props.data;
    if (draggedId !== afterId) {
      props.onMove(draggedId, afterId);
    }
  },
};

export default DropTarget(DESTINATION_NODE, taskTarget, dropFunc)(
    DragSource(DESTINATION_NODE, taskSource, dragFunc)(DraggableDestination)
);



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/dnd/DraggableDestination.js
 **/